module.exports = __webpack_public_path__ + "static/img/ma7.6a3cec1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ma7.gif
// module id = DWB8
// module chunks = 1